import React from 'react';
import IconClose from '../../assets/svg/IconClose.svg';
import HeaderSearchIcon from '../../assets/svg/HeaderSearchIcon.svg';
const config = {
  /**
   * TODO: Will be updated when the actual image provided by design team
   * or would be completely replaced by font-icons
   */
    svgSearchIconName: 'headersearchicon',
    svgSearchIconComponent: <HeaderSearchIcon/>,
    svgResetIconName: 'icon-close',
    svgResetIconComponent: <IconClose/>,
    showViewAll: 2,
};

export default config;
